import AppFunction from "../../../../../core/helpers/app/AppFunction.js";


export const TableHelpers = {
    data() {  
        return {
            tableColumns: [
                {
                    title: this.$t('contract_number'),
                    type: 'object',
                    key: 'contract',
                    modifier: (value, _) => {
                        return value ? value?.number : '';
                    }
                },

                {
                    title: this.$t('Shipment_type'),
                    type: 'media-object',
                    key: 'media-object',
                    default: AppFunction.getAppUrl('images/default-shipment.jpg'),
                    modifier: (value, row) => {
                        // console.log({row});
                        
                        const shipmentType = row.contract.shipment_type.toLowerCase() ?? null;
                        if (typeof shipmentType === 'string') {
                            if (shipmentType.startsWith('o')) {
                                return AppFunction.getAppUrl('images/barco.jpg');
                            }
                            if (shipmentType.startsWith('t')) {
                                return AppFunction.getAppUrl('images/camion.jpg');
                            }
                        }
                    },
                    isVisible: true,
                },
                
                {
                    title: this.$t('subcontract_number'),
                    type: 'text',
                    key: 'number',
                },

                {
                    title: this.$t('Supplier'),
                    type: 'object',
                    key: 'contract',
                    modifier: (value, _) => {
                        const {contract_suppliers} = value; 
                        if (contract_suppliers && contract_suppliers.length > 0) {
                            const data = contract_suppliers[0];
                            if (data.supplier_company) {
                                return data.supplier_company.Title || ''; 
                            }
                        }
                        return '';
                    }
                },

                {
                    title: this.$t('Customer'),
                    type: 'object',
                    key: 'contract',
                    modifier: (value, _) => {
                        const {contract_customer} = value;    
                        if (contract_customer && contract_customer.length > 0) {
                            const data = contract_customer[0];
                            if (data.customer_company) {
                                return data.customer_company.Title || ''; 
                            }
                        }
                        return '';
                    }
                },

                {
                    title: this.$t('Logistic coordinator'),
                    type: 'object',
                    key: 'contract',
                    modifier: (value, _) => {
                        const {logistic_user} = value;
                        if (logistic_user) {
                            return logistic_user.first_name + ' ' + logistic_user.last_name;
                        }
                        return '';
                    }
                },

            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
                modifier : (_) => {
                    return `class=text-center`
                }
            }
        }
    },
}